import React, { useCallback } from 'react'
import { UseFormHandleSubmit } from 'react-hook-form'

import ModalFooter from 'components/Luxkit/Modal/ModalFooter'
import { useAppSelector } from 'hooks/reduxHooks'
import { appViewMessageHandler } from 'lib/window/webViewUtils'
import { isHeadlessModeSel } from 'selectors/configSelectors'
import useModalCallbacks from 'tripPlanner/hooks/View/useModalCallbacks'
import { CLOSE_MODAL } from 'tripPlanner/types/common'

interface Props {
  onSubmit: ReturnType<UseFormHandleSubmit<any>>
  isLoading: boolean
}

export default function CreateModalFooter({ onSubmit, isLoading }: Props) {
  const isHeadless = useAppSelector(isHeadlessModeSel)
  const { closeModal } = useModalCallbacks()

  const onClose = useCallback(() => {
    closeModal()
    if (isHeadless) {
      appViewMessageHandler('nativeNavigation', CLOSE_MODAL)
    }
  }, [closeModal, isHeadless])

  return (
    <ModalFooter
      primaryActionProps={{
        children: 'Save',
        disabled: isLoading,
        onClick: onSubmit,
      }}
      secondaryActionProps={{
        children: 'Cancel',
        disabled: isLoading,
        onClick: onClose,
      }}
    />
  )
}
